import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import * as Http from '../../http'
import * as Business from '../../utils/business'
import { ErrorCode, AccountType, AccountTypeName } from '../../const'

export default class ListUser extends Component {
  state = {
    isShow: false
  }
  username = ''
  password = ''
  role = ''

  show = () => {
    this.username = ''
    this.password = ''
    this.accountType = AccountType.Admin
    this.role = Business.getFirstRoleId()
    this.phone = ''
    this.fullname = ''
    this.address = ''
    this.setState({
      isShow: true
    })
  }

  close = () => {
    this.setState({
      isShow: false
    })
  }

  save = () => {
    if (!this.username) {
      Business.showAlert({
        title: 'Error',
        content: 'You must enter the username'
      })
      return
    }
    // if (!this.password) {
    //   Business.showAlert({
    //     title: 'Error',
    //     content: 'You must enter the password'
    //   })
    //   return
    // }
    const newUserInfo = {
      UserName: this.username,
      Password: this.password,
      RoleGroupId: this.role,
      AccountType: AccountType.Admin,
      Address: this.address,
      Fullname: this.fullname,
      Phone: this.phone
    }

    Http.createUser(newUserInfo)
      .then(res => {
        if (res.Success) {
          Business.showAlert({
            title: 'Success',
            content: 'Create Account Success'
          })
          this.props.onCreateNewUser && this.props.onCreateNewUser()
          this.close()
        } else {
          switch (res.ErrorCode) {
            case ErrorCode.PermissionDenie:
              Business.showAlert({
                title: 'Error',
                content: 'You are not permission'
              })
              break;
            case ErrorCode.Exist:
              Business.showAlert({
                title: 'Error',
                content: 'This username already exists in the system'
              })
              break;
            default:
              break;
          }
        }
      })
  }

  render() {
    if (!this.state.isShow) return <div />

    return (
      <Modal show={this.state.isShow} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>Create User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="form-group">
              <label for="exampleInputEmail1">Username</label>
              <input type="text" className="form-control"
                id="exampleInputEmail1" aria-describedby="emailHelp"
                defaultValue={this.username}
                onChange={event => {
                  this.username = event.target.value
                }}
              />
            </div>
            <div className="form-group">
              <label for="fullname">Fullname</label>
              <input type="text" className="form-control" id="fullname" placeholder="Fullname"
                defaultValue={this.fullname}
                onChange={event => {
                  this.fullname = event.target.value
                }}
              />
            </div>
            {/* <div className="form-group">
              <label for="exampleFormControlSelect1">Account Type</label>
              <select className="form-control" id="exampleFormControlSelect1"
                onChange={event => {
                  this.accountType = Business.getAccountTypeId(event.target.value)
                }}
                defaultValue={Business.getAccountTypeName(this.accountType)}
              >
                <option>{AccountTypeName['1']}</option>
                <option>{AccountTypeName['2']}</option>
              </select>
            </div> */}
            <div className="form-group">
              <label for="exampleFormControlSelect1">Role</label>
              <select className="form-control" id="exampleFormControlSelect1"
                onChange={event => {
                  this.role = Business.getRoleIdByName(event.target.value)
                }}
              >
                {Business.getAllRoleName().map(item =>
                  (<option>{item}</option>)
                )}
              </select>
            </div>
            <div className="form-group">
              <label for="phone">Phone</label>
              <input type="text" className="form-control" id="phone" placeholder="Phone"
                defaultValue={this.phone}
                onChange={event => {
                  this.phone = event.target.value
                }}
              />
            </div>
            <div className="form-group">
              <label for="address">Address</label>
              <input type="text" className="form-control" id="address" placeholder="Address"
                defaultValue={this.address}
                onChange={event => {
                  this.address = event.target.value
                }}
              />
            </div>
            {/* <div className="form-group">
              <label for="exampleInputPassword1">Password</label>
              <input type="password" className="form-control" id="exampleInputPassword1" placeholder="Password"
                defaultValue={this.password}
                onChange={event => {
                  this.password = event.target.value
                }}
              />
            </div> */}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" style={{
            backgroundColor: '#FFE600',
            borderColor: '#7F7E82',
            borderRadius: '5px',
            marginRight: '2px',
            fontWeight: 600,
            marginLeft: "auto"
          }} onClick={this.save}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/User/NewUser.js